import { render } from "./ScoringInternalLoginPage.vue?vue&type=template&id=c8e91c0a&scoped=true"
import script from "./ScoringInternalLoginPage.vue?vue&type=script&lang=js"
export * from "./ScoringInternalLoginPage.vue?vue&type=script&lang=js"

import "./ScoringInternalLoginPage.vue?vue&type=style&index=0&id=c8e91c0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8e91c0a"]])

export default __exports__